BuyButton = window.BuyButton ?= {}

getBuyUrlWithShippingOptionData = require '../../../../goods_local_supply_v2/common/get_buy_url_with_shipping_options'
Affirm = require '../../../../affirm_info/frontend/affirm'
FetchHandler = require '../../../../deal/frontend/FetchHandler'
addGiftingToUrl = require('../../../common/add_gifting_to_url')

SCROLL_THRESHOLD = 460

class BuyButton.View
  constructor: ({@multiOptionEnabled, @multiOptionInline, @buyButtonEnabled, @hasVariations, @goodsCartFormEnabled}) ->
    @$el = $("#purchase-cluster, .multi-option-overlay, #header-purchase-cluster")
    @$buyContainer = @$el.find(".buy")
    @$buyButton = @$el.find("a.buy-button")
    @$giftButton = @$el.find("a.buy-for-friend")
    @$dealHeroPrice = @$el.find(".deal-hero-price, .multi-option-overlay-cluster-price")
    @$mainBtnPrice = @$el.find("#main-button-formatted-price")
    @$priceBox = @$el.find(".price, .multi-option-overlay-cluster-price")
    @$priceLabel = @$el.find(".price-label, .multi-option-overlay-cluster-price-label")
    @$value = @$el.find("#discount-value, .discount-value, .breakout-option-value")
    @$strikethroughPrice = @$el.find(".value-source-wrapper, .breakout-option-value")
    @$valueSourceWrapper = @$el.find(".value-source-wrapper")
    @$valueSourceLabel = @$el.find(".source-metadata-label")
    @$valueSourceDescription = @$el.find(".source-metadata-description")
    @$smallPrice = @$el.find(".discount-value")
    @$multiOptionBreakout = @$el.find('.multi-option-breakout, .modal-body')
    @$multiOptionOverlay = @$el.filter('.multi-option-overlay')
    @$multiOptions = @$el.find('.multi-option-breakout input, .multi-option-overlay-item input')
    @$finePrintDesc = @$el.find(".fine-print-description")
    @$headerTitles = @$el.find(".header-title-item")
    @$headerOptions = @$el.find(".header-options")
    @i18n = I18n.scoped() if I18n?
    @$discount = @$el.find(".breakout-messages .discount-message")
    @$valueBox = @$el.find(".multi-option-overlay-cluster-value")
    @$overlayCluster = @$el.find(".multi-option-overlay-cluster")
    @$soldBox = @$overlayCluster.find("div.sold-message")
    @$discountBox = @$overlayCluster.find("div.discount-message")
    @$discountBadge = @$el.find("div.discount-message-wrapper div.discount-message")
    @$expirationBox = @$overlayCluster.find("div.expiration")
    @$overlayList = @$el.find('.multi-option-overlay-list')
    @$overlayFade = @$el.find('.scroll-fade-overlay')
    @$purchaseCreditsMessagingPlaceHolder = @$el.find('.purchase-credits-messaging.placeholder')
    @$goodsWarrantyOption = @$el.find('.goods-warranty-option')
    @$doubleStrike = @$el.find('.double-strike .breakout-option-regular-price')
    @$doubleStrikeCluster = @$el.find('.multi-option-overlay-cluster-pricing.double-strike .breakout-option-regular-price')

    if @$purchaseCreditsMessagingPlaceHolder.length
      @fetchAndDisplayPurchaseCreditsMessage().send()

    if @hasVariations
      @$priceBox = @$el.find(".price, .multi-option-overlay-cluster-price, .breakout-option-price")
      @$urgencyPricingMessage = @$multiOptionBreakout.find('.urgency-pricing-label')
      @$soldMessage = @$multiOptionBreakout.find('.sold-message')

    if @$multiOptionOverlay.length
      @$discountPercent = @$el.find('#discount-percent, .discount-percent')
      @$discountYouSave = @$el.find('#discount-you-save, .discount-you-save')
      @$qtyBought = @$el.find('.qty-bought')
      @$dealStatus = @$el.find('.deal-status')
      @fixPossiblePriceOverflow()

    @hasBeenClicked = false
    @variationsSelected = false

    if @multiOptionInline
      @restoreOptionSelection()

    processLink = =>
      @processLink()

    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000)

    window.DealEventPipe.on "priceUpdate", (priceData) =>
      @variationsSelected = priceData.variationsSelected
      @$buyButton.removeClass("login-disabled")
      @updatePrice priceData
      @updateValue priceData
      @updateMSRP priceData
      @updateDiscount priceData
      @updateSoldMessage priceData
      @updateBuyButton priceData
      @updateAffirmPrice priceData

    @$overlayList.on 'scroll', =>
      @handleFadeout()

    @$el.find("a.buy-button:not(.external-buy)").on("click", @buyButtonClicked)
    @$el.find(".view-options a").on("click", @viewAllOptions)
    @$multiOptions.on("click", @updateMultiOptionBreakoutButton)
    @$el.find(".multi-option-overlay-cluster a div.text").on("click", @goToTips)

  handleFadeout: ->
    if @$overlayList[0].scrollHeight <= SCROLL_THRESHOLD
      return
    if @$overlayList.scrollTop() + @$overlayList.innerHeight() >= @$overlayList[0].scrollHeight
      if @$overlayFade.is(':visible')
        @$overlayFade.hide()
    else if !@$overlayFade.is(':visible')
      @$overlayFade.show()

  buyButtonClicked: (e) ->
    e.preventDefault()
    BuyButton.eventBus.go 'buy_button_clicked', e

  shouldShowPriceInTwoRows: ->
    includeMargin = true
    @$priceBox.outerWidth(includeMargin) + @$smallPrice.outerWidth(includeMargin) > @$dealHeroPrice.outerWidth(includeMargin)

  setPriceWithSale: (newPrice) ->
    @$priceBox.text newPrice
    @fixPossiblePriceOverflow()

  setOfferLabel: (offerLabel) ->
    return unless offerLabel?.length

    if @hasVariations
      @$urgencyPricingMessage.text offerLabel
      @$soldMessage.hide()
      @$priceBox.addClass 'urgency-pricing'
    else
      offerLabel = "<span class='urgency-pricing-label'>#{offerLabel}</span>"
      @$dealHeroPrice.append offerLabel
      @$dealHeroPrice.addClass 'urgency-pricing'

  cleanPriceBox: ->
    if @hasVariations
      @$urgencyPricingMessage.text('')
      @$soldMessage.text('').show()
    else
      @$priceBox.removeClass 'two-rows'
      @$priceBox.find('.urgency-pricing-label').remove()
      @$dealHeroPrice.removeClass 'urgency-pricing'

    @$priceBox.removeClass 'txt-price c-txt-err urgency-pricing'

  setDoubleStrikePrice: (regularPrice) ->
    return unless @$doubleStrike.length

    if regularPrice
      @$doubleStrike.text(regularPrice).show()
    else
      @$doubleStrike.text('').hide()

  setPriceBox: (price, sale, variationsSelected) ->
    @cleanPriceBox()
    if sale?.urgencyPricing?
      @setPriceWithSale sale.urgencyPricing.newPrice
      @setOfferLabel sale.urgencyPricing.pricingMetadata?.offerLabel, variationsSelected
      @setDoubleStrikePrice sale.urgencyPricing.regularPrice
      if sale.urgencyPricing.pricingMetadata
        @$priceBox.removeClass 'c-txt-price'
        @$priceBox.addClass 'c-txt-err urgency-pricing'
      else
        @$priceBox.addClass 'c-txt-price'
        @$priceBox.removeClass 'c-txt-err urgency-pricing'
    else if sale?.offer?
      @$mainBtnPrice.text sale.offer.formattedNewPrice
      @setPriceWithSale sale.offer.formattedOldPrice
      @setDoubleStrikePrice null
    else
      @$priceBox.text price
      @$priceBox.addClass 'c-txt-price'
      @setDoubleStrikePrice null

  updatePrice: ({ lengthClass, price, sale, variationsSelected }) ->
    @$buyContainer.removeClass @currentPriceClass if @currentPriceClass
    @$buyContainer.addClass lengthClass if lengthClass
    @setPriceBox price, sale, variationsSelected
    @currentPriceClass = lengthClass
    if variationsSelected and @$strikethroughPrice?.length
      @$priceLabel.hide()
      @$valueSourceWrapper.show()
      @$valueSourceWrapper.css("display", "flex")
      @$value.show()
    else
      @$priceLabel.show()

  updateAffirmPrice:  ({affirmAmount}) ->
    Affirm.updateAffirmPrice(affirmAmount)

  updateValue: ({ value, hideOriginalPriceAndDiscount }) ->
    @$value.html if hideOriginalPriceAndDiscount then "" else value

  updateMSRP: ({ valueSourceMetadata, hideOriginalPriceAndDiscount }) ->
    if valueSourceMetadata?.label and valueSourceMetadata?.description and not hideOriginalPriceAndDiscount
      { label, description } = valueSourceMetadata
      @$valueSourceLabel.html label
      @$valueSourceDescription.html description
    else
      @$valueSourceLabel?.html ""
      @$valueSourceDescription?.html ""

  cleanClusterDiscount: (urgent) ->
    badge = @$overlayCluster.find('.discount-message')
    if urgent
      badge.removeClass('c-txt-price c-bdr-price')
      badge.addClass('c-txt-err c-bdr-err urgency-pricing')
    else
      badge.removeClass('c-txt-err c-bdr-err urgency-pricing')
      badge.addClass('c-txt-price c-bdr-price')

  cleanDiscount: (sale) ->
    if @hasVariations and sale?.urgencyPricing and sale?.urgencyPricing.pricingMetadata
      @$discountBadge.removeClass('c-txt-price c-bdr-price')
      @$discountBadge.addClass('c-txt-err c-bdr-err urgency-pricing')
    else if @hasVariations and (not sale?.urgencyPricing || not sale?.urgencyPricing.pricingMetadata)
      @$discountBadge.removeClass('c-txt-err c-bdr-err urgency-pricing')
      @$discountBadge.addClass('c-txt-price c-bdr-price')

  updateDiscount: ({ percent, hideOriginalPriceAndDiscount, sale, showDifferenceMessage }) ->
    @cleanDiscount(sale)

    unless hideOriginalPriceAndDiscount
      if percent
        if showDifferenceMessage
          discountHtml = @i18n.t 'js.modules.buy_button.multi_option.difference_percentage', rawDiscountPercentage: percent
        else
          discountHtml = @i18n.t 'js.modules.buy_button.multi_option.discount_percentage', rawDiscountPercentage: percent

    @$discount.html(discountHtml ?= "")

    if percent
      discountHtml = @i18n.t("js.modules.buy_button.multi_option.off_with_value", discountPercentage: percent)
      @$discountBadge.html(discountHtml ?= "")
      @$discountBadge.show()
    else
      @$discountBadge.hide()

  updateSoldMessage: ({ variationsSelected, soldMessage }) ->
    @$soldMessage.text(soldMessage) if variationsSelected

  updateBuyButton: (option) ->
    { variationsSelected, buyUrl, dealUuid, uuid } = option

    if variationsSelected
      if @goodsCartFormEnabled
        @updateGoodsCartForm(dealUuid, uuid)
      else
        buyUrl = localSupplyUrl if localSupplyUrl = @getLocalSupplyUrl(option)
        @$buyButton.attr("href", buyUrl)
        @$giftButton.attr("href", addGiftingToUrl(buyUrl))

  updateGoodsCartForm: (dealUuid, optionUuid) ->
    window.DealEventPipe.trigger('cartFormInitialize', {dealUuid, uuid: optionUuid})

  getLocalSupplyUrl: ({ buyUrl }) ->
    return unless shippingOptionData = GoodsLocalSupply?.View?.getSelectedShippingOptionData()
    getBuyUrlWithShippingOptionData buyUrl, shippingOptionData

  disableBuyButton: ->
    @hasBeenClicked = true
    @$buyButton.addClass("loading")
    @$buyButton.removeClass("state-buy")
    @$buyButton.addClass("state-disabled")
    @$headerOptions.fadeOut()

  enableBuyButton: ->
    @hasBeenClicked = false
    @$buyButton.removeClass("loading")
    @$buyButton.removeClass("state-disabled")
    @$buyButton.addClass("state-buy")
    @$headerOptions.fadeIn()

  processLink: ->
    return unless @buyButtonEnabled
    unless @hasBeenClicked
      if @goodsCartFormEnabled and not @$goodsWarrantyOption.is(':checked')
        window.DealEventPipe.trigger('cartFormSubmit')
      else
        newUrl = @$buyButton.attr("href")

        window.location = newUrl

    @disableBuyButton()

  updateMultiOptionBreakoutButton: (e) =>
    $option = @$multiOptions.filter(e.currentTarget)
    return if !$option.length or $option.hasClass('selected') or !@buyButtonEnabled

    @$multiOptions.removeClass 'selected'
    $option.addClass 'selected'

    value = $option.val()
    {deal, offerLabel, uuid} = $option.data()
    optionInfo = { buyUrl: value, dealUuid: deal, uuid }
    value = localSupplyUrl if localSupplyUrl = @getLocalSupplyUrl optionInfo

    if @goodsCartFormEnabled
      @updateGoodsCartForm(deal, uuid)
    else
      @$buyButton.attr 'href', value
      @$giftButton.attr 'href', addGiftingToUrl(value)

    if @$multiOptionOverlay.length
      @updateClusterOptionPrice($option)
      @syncDealOptions($option)
      @cleanPriceBox()
      @cleanClusterDiscount(offerLabel)
      @setOfferLabel $option.attr('data-offer-label')
      @fixPossiblePriceOverflow()
    else
      @updateHeaderPrice($option)

    @updateHeaderTitle($option)

    BuyButton.eventBus.go('buy_button_clicked', e) if $option.parent('a').length

  updateHeaderPrice: ($option) ->
    formattedPrice = $option.attr('data-formatted-price') or ''
    formattedValue = if formattedPrice is $option.attr('data-formatted-value') then '' else $option.attr('data-formatted-value')
    @$priceBox.text(formattedPrice)
    @$smallPrice.text(formattedValue)

  updateHeaderTitle: ($option) ->
    breakoutOptionID = @getPurchaseClusterOptionId($option.attr('id'))
    @$headerTitles.removeClass 'checked'
    targetTitleId = "#header-title-#{breakoutOptionID}"
    selectedTitle = @$headerTitles.filter(targetTitleId)
    selectedTitle.addClass 'checked'

  updateClusterOptionPrice: ($option) ->
    formattedPrice = $option.attr('data-formatted-price') or ''
    formattedValue = if formattedPrice is $option.attr('data-formatted-value') then '' else $option.attr('data-formatted-value')
    offerLabel = $option.attr('data-offer-label') or ''
    soldMessage = $option.attr('data-sold-message') or ''
    breakoutOptionID = @getPurchaseClusterOptionId($option.attr('id'))
    finePrintDesc = $option.attr('data-description') or ''

    @$priceBox.text(formattedPrice)
    @$smallPrice.text(formattedValue)
    @$valueBox.text(formattedValue)
    @$soldBox.text(soldMessage)
    @fixPossiblePriceOverflow()

    if @$doubleStrikeCluster.length
      formattedRegularPrice = $option.attr('data-formatted-regular-price')
      if formattedRegularPrice
        @$doubleStrikeCluster.text(formattedRegularPrice)
      else
        @$doubleStrikeCluster.text('')

    # optional elements may or may not exist
    @updateClusterOptionDiscount($option)
    @updateExpiration($option)
    @$priceBox.find('.urgency-pricing-label').text(offerLabel)
    @updateUrgencyPricingMetaData(offerLabel, breakoutOptionID)

    if offerLabel
      @$priceBox.removeClass('c-txt-price')
      @$priceBox.addClass('c-txt-err c-bdr-err')
    else
      @$priceBox.addClass('c-txt-price')
      @$priceBox.removeClass('c-txt-err c-bdr-err')

    if soldMessage.length
      @$qtyBought.text(soldMessage)
      @$dealStatus.show()
    else
      @$dealStatus.hide()

    @updateFinePrint(finePrintDesc)

  updateExpiration: ($option) ->
    expiration = $option.attr('data-expiration') or ''
    @$expirationBox.text(expiration)

  updateClusterOptionDiscount: ($option) ->
    @cleanDiscount()
    discountPercentage = $option.attr('data-discount-percentage') or ''
    savings = $option.attr('data-savings') or ''
    if discountPercentage
      @$discountPercent.text(discountPercentage)
      @$discountYouSave.text(savings)
      $('.deal-discount').show()
    else
      $('.deal-discount').hide()
    @$discountBox.text(discountPercentage)

  updateUrgencyPricingMetaData: (offerLabel, breakoutOptionID) ->
    if offerLabel
      @$dealHeroPrice.addClass('urgency-pricing')
        .attr('data-bhw', 'UrgencyPrice')
    else
      @$dealHeroPrice.addClass('c-txt-price')
      @$dealHeroPrice.removeClass('urgency-pricing')
        .removeAttr('data-bhw')

  fixPossiblePriceOverflow: ->
    @$priceBox.removeClass('two-rows')
    @$smallPrice.removeClass('two-rows')
    if @shouldShowPriceInTwoRows()
      @$priceBox.addClass('two-rows')
      @$smallPrice.addClass('two-rows')

  viewAllOptions: (e) =>
    e.preventDefault()
    BuyButton.eventBus.go 'view_options_clicked', e
    if @$overlayList[0]?.scrollHeight <= SCROLL_THRESHOLD
      @$overlayFade.hide()

  restoreOptionSelection: () ->
    @$el.find('.multi-option-breakout li input:first').trigger 'click'

  syncDealOptions: ($option) ->
    optionId = $option.attr('id')

    if optionId.indexOf('overlay') != -1
      breakoutOptionId = "##{@getPurchaseClusterOptionId(optionId)}"
      @reorderDealOptions(breakoutOptionId)
    else
      breakoutOptionId = "#overlay-#{optionId}"

    $(breakoutOptionId).prop('checked', true)

  getPurchaseClusterOptionId: (optionId) ->
    return '' unless optionId?

    return optionId.replace('overlay-', '')

  reorderDealOptions: (breakoutOptionId) ->
    $optionElem = $(breakoutOptionId).parents('li')

    return if $optionElem.is(':visible')

    $optionElem.insertBefore($optionElem.siblings('li').first())
    $optionElem.parent().find('li:visible:last').hide()
    $optionElem.show()

  updateFinePrint: (finePrintDesc) ->
    return unless finePrintDesc?.length
    $body = $(document.body)
    @$finePrintDesc.html finePrintDesc

  goToTips: (e) ->
    e.preventDefault()
    GIG.Modal.close()
    window.location.href = "#tips"

  handleAjaxResponse: (res) ->
    if res && res.amount && res.unit
      amount = "<span class='c-txt-price' data-bhc='numBucks:#{res.amount}'>$#{res.amount}</span>"
      unit = res.unit

      purchaseCreditsMessage = @i18n.t 'js.modules.buy_button.new_purchase_credits_messaging', {amount, unit}
      @$purchaseCreditsMessagingPlaceHolder.attr('data-bhw', 'BucksDealPageDisplay')
      @$purchaseCreditsMessagingPlaceHolder.html("<span class='icon-bucks c-txt-price'></span><div>#{purchaseCreditsMessage}</div>")
      @$purchaseCreditsMessagingPlaceHolder.removeClass('placeholder')
    else
      @$purchaseCreditsMessagingPlaceHolder.remove()

  fetchAndDisplayPurchaseCreditsMessage: ->
    new FetchHandler(
      url: '/deals/user_proxy/available_credits',
      requestOpts: {credentials: 'same-origin'},
      successHandlers: @handleAjaxResponse.bind(this)
    )

module.exports = BuyButton.View
